import uthaya from "../assets/images/jointSecretaries/uthayalaxmi.jpg";
import jaya from "../assets/images/jointSecretaries/jayapradaaramachandran.jpg";
import nagarjuna from "../assets/images/jointSecretaries/nagarjuna.webp";
import shraeya from "../assets/images/jointSecretaries/keerthi.webp";
import vishnu from "../assets/images/jointSecretaries/vishnuprasannaa.webp";
import naveen from "../assets/images/jointSecretaries/naveenraja.webp";
import ananya from "../assets/images/jointSecretaries/ananyasudakar.webp";
import deepak from "../assets/images/jointSecretaries/deepak.jpg";
import boobesh from "../assets/images/jointSecretaries/boobesh.webp";
import animaria from "../assets/images/jointSecretaries/animaria.webp";
import shafi from "../assets/images/jointSecretaries/shafi.webp";
import keerthana from "../assets/images/jointSecretaries/keerthanakaleeswari.jpg";
import akalya from "../assets/images/jointSecretaries/akalyasenthilkumar.webp";
import jaipriya from "../assets/images/jointSecretaries/jaipriya.webp";
import Srinithin from "../assets/images/jointSecretaries/srinithin.webp";
import Kirish from "../assets/images/jointSecretaries/kirishkanna.jpg";
import dhaarini from "../assets/images/jointSecretaries/dhaarinirajasekaran.webp";
import thosithaa from "../assets/images/jointSecretaries/thosithaalakshmi.webp";

const JsDetails = [
  {
    name: "Akalya S",
    designation: "Joint Secretary",
    photo: akalya,
    
  },
  {
    name: "Ananya Sudakar",
    designation: "Joint Secretary",
    photo: ananya,
    linkedin: "https://in.linkedin.com/in/ananya-sudakar"
  },
  {
    name: "Animaria A",
    designation: "Joint Secretary",
    photo: animaria,
    linkedin: "https://www.linkedin.com/in/animaria-a-1a404a33a/"
  },
  {
    name: "Boobesh A",
    designation: "Joint Secretary",
    photo: boobesh,
    linkedin: "https://www.linkedin.com/in/boobesh-a-b21552315/"
  },
  {
    name: "Deepak M",
    designation: "Joint Secretary",
    photo: deepak,
    linkedin: "https://www.linkedin.com/in/deepak12004"
  },
  {
    name: "Dhaarini R",
    designation: "Joint Secretary",
    photo: dhaarini,
    linkedin: "https://www.linkedin.com/in/dhaarini-r-46618a35b"
  },
  {
    name: "Jaipriya P",
    designation: "Joint Secretary",
    photo: jaipriya,
    
  },
  {
    name: "Jayapradaa Ramachandran",
    designation: "Joint Secretary",
    photo: jaya,
    linkedin: "https://www.linkedin.com/in/jayapradaa-ramachandran-b4249633a/"
  },
  {
    name: "Keerthana M K",
    designation: "Joint Secretary",
    photo: keerthana,
    linkedin: "https://www.linkedin.com/in/keerthana-m-k-510272323/"
  },
  {
    name: "Kirish Kanna K B B",
    designation: "Joint Secretary",
    photo: Kirish,
    linkedin: "https://www.linkedin.com/in/kirishkannakbb/"
  },
  {
    name: "Nagarjuna N G",
    designation: "Joint Secretary",
    photo: nagarjuna,
    
  },
  {
    name: "Naveen Raja S",
    designation: "Joint Secretary",
    photo: naveen,
    linkedin: "https://www.linkedin.com/in/naveen-raja-9647b336a/"
  },
  {
    name: "Shafiulla S",
    designation: "Joint Secretary",
    photo: shafi,
    
  },
  {
    name: "Shraeya Sharmiladevi Keerthi",
    designation: "Joint Secretary",
    photo: shraeya,
    linkedin: "https://www.linkedin.com/in/shraeya-sharmiladeve-keerthi-74668b319/"
  },
  {
    name: "Srinithin S",
    designation: "Joint Secretary",
    photo: Srinithin,
    linkedin: "https://www.linkedin.com/in/srinithin-ganeshkumar-02b2a6315/"
  },
  {
    name: "Thosithaa Lakshmi N",
    designation: "Joint Secretary",
    photo: thosithaa,
    linkedin: "https://www.linkedin.com/in/thosithaa-lakshmi-n-58288a31a/"
  },
  {
    name: "Uthaya Laxmi AP",
    designation: "Joint Secretary",
    photo: uthaya,
    linkedin: "https://www.linkedin.com/in/uthaya-laxmi-7a43a4352/"
  },
  {
    name: "Vishnu Prasanna V",
    designation: "Joint Secretary",
    photo: vishnu,
    linkedin: "https://www.linkedin.com/in/vishnu-prasannaa-05v/"
  }
];

export default JsDetails;
